export const getCoachingSession = async (sessionId: string) => {
	const coachingSession = await fetch('/api/sessions/coaching-session/getSession', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({ sessionId }),
	});

	const updatedSessionData = await coachingSession.json();
	return updatedSessionData;
};
